// Step 5: Items - What's Included and What to Bring
// Always optional; uses the existing SharedItemsManager component

import React from 'react';
import { Tour } from '../../../types/tours';
import SharedItemsManager from '../SharedItemsManager';

interface StepItemsProps {
  formData: Partial<Tour>;
  onItemsChange: (field: 'include_items' | 'bring_items', items: string[]) => void;
}

const StepItems: React.FC<StepItemsProps> = ({ formData, onItemsChange }) => {
  return (
    <div className="space-y-6">
      <div className="bg-[#1F2B1F] rounded-xl p-6 border border-white/10">
        <SharedItemsManager
          type="include"
          selectedItems={formData.include_items || []}
          onItemsChange={(items) => onItemsChange('include_items', items)}
        />
      </div>

      <div className="bg-[#1F2B1F] rounded-xl p-6 border border-white/10">
        <SharedItemsManager
          type="bring"
          selectedItems={formData.bring_items || []}
          onItemsChange={(items) => onItemsChange('bring_items', items)}
        />
      </div>
    </div>
  );
};

export default StepItems;
